import { useMutation } from 'react-query';
import { StatusResponse } from '../../../../../../../../types/API';
import { wgApi } from '../../../../../../../app/src/features/api/wgApi';

interface Params {
  sessionId: string;
  entityId: string;
  partyId?: string;
}

const deleteEntity = async ({ sessionId, entityId, partyId }: Params) => {
  const path = partyId
    ? `/v1/api/conversations/${sessionId}/entities/${entityId}/parties/${partyId}`
    : `/v1/api/conversations/${sessionId}/entities/${entityId}`;
  const { data, isError } = await wgApi.delete<StatusResponse>(path);
  if (isError) throw new Error();
  return data;
};

export const useDeleteEntity = () => {
  return useMutation(deleteEntity);
};
